module.exports = __webpack_public_path__ + "img/card_head_bg.cd08eb73.webp";